import aiAvatarLight from '../../../assets/aiAvatarLight.svg';
import aiAvatarDark from '../../../assets/aiAvatarDark.svg';
import {useAppStore} from "../../../GlobalStore/GlobalStore.ts";

const CenteredLogo = () => {
    const settingsObj = useAppStore((state: any) => state.settingsObj);
    const { theme } = settingsObj;
    const environmentObj = useAppStore((state: any) => state.environmentObj);
    const { environment } = environmentObj;

    const getLogo = () => {
        if (environment === "vscode") {
            return theme === "dark" ? "https://wfclardozsxtrutoorim.supabase.co/storage/v1/object/public/images//aiAvatarLight.svg" : "https://wfclardozsxtrutoorim.supabase.co/storage/v1/object/public/images//aiAvatarDark.svg";
        }
        else {
            return theme === "dark" ? aiAvatarLight : aiAvatarDark;
        }
    }
    const logo = getLogo();

    return (
        <div className="flex justify-center items-center h-full">
            <img
                src={`${logo}`}
                alt="AI Avatar"
                className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-[82%] w-36 h-36 md:w-44 md:h-44"
                draggable="false"
                onContextMenu={(e) => e.preventDefault()}
            />
        </div>
    );
};

export default CenteredLogo;
